import * as React from 'react'
import { useEffect } from 'react'

import AppComponent from './App'
import { useTranslation } from 'react-i18next'
import { useLocalizationEnabled } from '@user/store/tenantFeatures/hooks/useLocalizationEnabled'

import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { useSelector } from 'react-redux'
import { TenantLocale } from '@sales-center/common'

export const App = () => {
  const { i18n } = useTranslation()
  const localizationEnabled = useLocalizationEnabled()

  const { tenantLocale } = useSelector(selectCurrentUser)

  useEffect(() => {
    let localizedLanguage = 'en'

    if (
      localizationEnabled &&
      tenantLocale &&
      tenantLocale == TenantLocale.CANADA
    ) {
      localizedLanguage = 'ca'
    }
    i18n.changeLanguage(localizedLanguage)
  }, [i18n, localizationEnabled, tenantLocale])
  return <AppComponent />
}
